/**
 * @fileoverview Functionality for manipulating ApolloClientOptions
 */
import { InMemoryCache } from '@apollo/client/core/index.js';
import { default as deepmerge } from 'deepmerge';
/**
 * The default base for client options
 */
export const defaultClientOptions = {
    cache: new InMemoryCache(),
    defaultOptions: {
        mutate: {
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
        },
        query: {
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
        },
        watchQuery: {
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
        },
    },
    ssrMode: false,
};
/**
 * Combines two ApolloClientOptions objects together
 */
export const mergeTwoClientOptions = (clientOptions = {}, newClientOptions) => {
    if (!newClientOptions) {
        return clientOptions;
    }
    // make disconnected versions
    const obj1 = { ...clientOptions };
    const obj2 = { ...newClientOptions };
    // do not try to merge cache
    const cache = obj2.cache || obj1.cache;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    obj2.cache && delete obj2.cache;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    obj1.cache && delete obj1.cache;
    const merged = deepmerge(obj1, obj2);
    if (cache) {
        merged.cache = cache;
    }
    return merged;
};
/**
 * Combines ApolloClientOptions objects with optional
 *  immutable options
 */
export const mergeClientOptions = (clientOptions = {}, newClientOptions, immutableOptions) => {
    let mergedOpts = mergeTwoClientOptions(clientOptions, newClientOptions);
    if (immutableOptions) {
        mergedOpts = mergeClientOptions(mergedOpts, immutableOptions);
    }
    return mergedOpts;
};
//# sourceMappingURL=client-options.js.map